export const terminos =
<div>
<p>
    Esta página utiliza las cookies técnicas necesarias para el funcionamiento y una adicional para recordar tu usuario asociado, éste se crea al ingresar por primera vez
    a la página y permitirá recordar tu nombre al ingresar un nuevo comentario y borrar los comentarios que has agregado previamente, si en algún momento borras
    las cookies de tu navegador no podrás borrar esos comentarios.
</p>
</div>